import Rails from "@rails/ujs";

import "./images";
import "./javascripts";
import "./stylesheets/";

Rails.start();
